export class ILogin {
    identifiant: string;
    password: string;
}